class MFRLottie {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.url = this.$element.data( "lottie-file" );

        this.init();
    }

    init() {
        console.log( this.url );
    }
}